"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCardsEndpoints = createCardsEndpoints;
/**
 * Sanal kartvizit ve QR ile ÇİFT TARAFLI kart değişimi.
 */
function createCardsEndpoints(client) {
    return {
        cards: {
            list: () => client.call('/cards', 'get', {}),
            get: (cardId) => client.call('/cards/{id}', 'get', { path: { id: cardId } }),
            create: (input) => client.call('/cards', 'post', { body: input }),
            update: (cardId, input) => client.call('/cards/{id}', 'patch', { path: { id: cardId }, body: input }),
            remove: (cardId) => client.call('/cards/{id}', 'delete', { path: { id: cardId } }),
            /*
             * KART PAYLASIM BAGLANTISI (C-15). Dort ucun DORDU de OTURUM ISTER —
             * kimliksiz bir varyant YOKTUR (kullanici karari, 2026-08-23).
             */
            linkStatus: (cardId) => client.call('/cards/{cardId}/link', 'get', { path: { cardId } }),
            openLink: (cardId) => client.call('/cards/{cardId}/link', 'post', { path: { cardId } }),
            revokeLink: (cardId) => client.call('/cards/{cardId}/link', 'delete', { path: { cardId } }),
            /** Baglantiyi ACAR — giris zorunludur; jeton yol parametresidir. */
            sharedCard: (token) => client.call('/card-links/{token}', 'get', { path: { token } }),
        },
        /**
         * QR ile çift taraflı kartvizit değişimi (Epic 17).
         *
         * KIRMIZI ÇİZGİ 1: burada "değişimi tamamla" diye bir uç YOKTUR ve
         * olmayacaktır. İstemci yalnız KENDİ onayını bildirir (`approve`);
         * karşılaşma satırını sunucu İKİ onayı da gördükten sonra açar ve kararı
         * veritabanı kısıtı verir.
         */
        cardExchanges: {
            /** C-01 — kısa ömürlü QR jetonu + kısa kod. Her çağrı öncekini düşürür. */
            share: (input, eventId) => client.call('/card-exchanges/share-token', 'post', {
                body: input,
                query: (eventId ? { eventId } : {}),
            }),
            /** C-02/C-09 — kod okundu, TEKLİF açılır. Taramak onay DEĞİLDİR (D1). */
            create: (input) => client.call('/card-exchanges', 'post', { body: input }),
            /** C-04'ün soğuk açılış yolu: çağırana açık duran teklifler. */
            pending: () => client.call('/card-exchanges/pending', 'get', {}),
            get: (exchangeId) => client.call('/card-exchanges/{exchangeId}', 'get', { path: { exchangeId } }),
            /** YALNIZ ÇAĞIRANIN KENDİ onayı; karşı tarafınki bu uçtan yazılamaz. */
            approve: (exchangeId) => client.call('/card-exchanges/{exchangeId}/approve', 'post', { path: { exchangeId } }),
            /** "Vazgeç" — 204, gövde yok (kapanmış teklifin durumu okunmaz). */
            decline: (exchangeId) => client.call('/card-exchanges/{exchangeId}/decline', 'post', { path: { exchangeId } }),
        },
    };
}
//# sourceMappingURL=cards.js.map